export const SET_IMAGE_STICKY = 'SET_IMAGE_STICKY';
export const REMOVE_IMAGE_STICKY = 'REMOVE_IMAGE_STICKY';
export const SET_IMAGE_PARTIAL_STICKY = 'SET_IMAGE_PARTIAL_STICKY';
